/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Compare_Event_Groups_Similarity_TitleInputs */



/**
* | output |
* | --- |
* | "Similarity: {percent}%" |
*
* @param {Compare_Event_Groups_Similarity_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_similarity_title = /** @type {((inputs: Compare_Event_Groups_Similarity_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Similarity_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Similarité : ${i?.percent} %`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ähnlichkeit: ${i?.percent}%`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Somiglianza: ${i?.percent}%`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сходство: ${i?.percent}%`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Similitud: ${i?.percent}%`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`相似度：${i?.percent}%`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`類似度: ${i?.percent}%`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`समानता: ${i?.percent}%`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Similaridade: ${i?.percent}%`)
	return /** @type {LocalizedString} */ (`Similarity: ${i?.percent}%`)
});